import get from 'lodash.get';

import React from "react";
import BatchPrint from "../BatchPrint";

import { getReport as fetchProgressReport } from "../../services/progress";
import ProgressReportBatchPrintRenderer from './ProgressReportBatchPrintRenderer';
import { fetchScaledCutlines as fetchScaledCutlinesAPI } from '../../../../services/query/benchmarkReportAPI';
import store from '../../../../store';

// Batch Print for Parent Report

export default function ProgressReportBatchPrint() {
  return (
    <BatchPrint
      title="Progress Report"
      getStudentData={getStudentData}
      renderReport={(report, i) => <ProgressReportBatchPrintRenderer report={report} i={i}/> }
      />
  );

  async function getStudentData(student, selections) {
    const { metric, scale, benchmark, customBenchmarks, equating, locale } =
      selections;

    // Get scaled cutlines for background colors (similar to Redux creators)
    let scaledCutlines = null;
    const state = store.getState();
    const districtId = get(state, 'reports.roster.data.district[0].id');
    const schoolId = get(state, 'reports.roster.data.school[0].id');

    if (districtId && schoolId && student?.grade !== undefined) {
      try {
        const assessmentCalendar = state.calendar.assessmentCalendar;
        if (assessmentCalendar?.periods?.length > 0) {
          const periodIds = assessmentCalendar.periods.map(period => period.periodIdentifier);
          const params = {
            districtId,
            schoolId,
            grade: student.grade,
            scale: state.userEntitlement.data.scoreType || "ARM",
            periodId: periodIds
          };
          
          const fetchedCutlines = await fetchScaledCutlinesAPI(params);
          
          // Ensure we have a valid array
          if (Array.isArray(fetchedCutlines)) {
            scaledCutlines = fetchedCutlines;
            console.log("✅ Batch Print: Successfully set scaledCutlines for", student.label);
          } else {
            console.warn("❌ Batch Print: API returned non-array cutlines:", typeof fetchedCutlines, fetchedCutlines);
            scaledCutlines = null;
          }
        } else {
          console.warn("❌ Batch Print: No assessment calendar periods available");
        }
      } catch (error) {
        console.error("❌ Batch Print: Error fetching scaled cutlines:", error);
      }
    } else {
      console.warn("❌ Batch Print: Missing required data for cutlines");
    }

    const additionalProps = {};
    
    const [progressReport] = await 
      fetchProgressReport(
        student,
        metric.value,
        scale.value,
        equating,
        locale,
        additionalProps,
        scaledCutlines
      );
    return { student, progressReport };
  }
}